module.exports = __webpack_public_path__ + "assets/img/modal-avatar-14603db0.png";